import { CloseRounded, SearchRounded } from '@mui/icons-material'
import { ChangeEvent, useRef, useState } from 'react'
import styled from 'styled-components'
import { Theme } from 'theme/theme'

interface ISearchInput {
  placeholder: string
  onChange?: (value: string) => void
  onSubmit?: (value: string) => void
  displayCloseCross?: boolean
  displaySearch?: boolean
  wrapperStyle?: React.CSSProperties
}

export default function SearchInputSync({
  placeholder,
  onChange,
  onSubmit,
  displayCloseCross,
  wrapperStyle = {},
}: Readonly<ISearchInput>) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [toValidate, setToValidate] = useState(false)

  return (
    <Wrapper style={wrapperStyle}>
      <Input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          if(!!onSubmit) setToValidate(true)
          onChange?.(e.target.value)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            setToValidate(false)
            onSubmit?.(e.currentTarget.value)
          }
        }}
      />
      {displayCloseCross ? (
        <CloseCrossWrapper
          onClick={() => {
            if (inputRef.current?.value) inputRef.current.value = ''
            onChange?.(null)
            onSubmit?.(null)
          }}
        >
          {inputRef?.current?.value ? <CloseRounded /> : null}
        </CloseCrossWrapper>
      ) : null}

      <div
        style={{
          display: 'flex',
          backgroundColor: (onChange || (inputRef.current?.value && toValidate)) ? Theme.colors.blueArtizen : Theme.colors.greyLight,
          color: 'white',
          height: '100%',
          width: 58,
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <SearchRounded onClick={() => {
          setToValidate(false)
          onSubmit?.(inputRef.current?.value || '')
        }} />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border: solid 1px;
  border-radius: 4px;
  background-color: white;
  border-color: ${(props) => props.theme.fourthColor};
  color: ${(props) => props.theme.secondaryColor};
  width: 100% !important;
  height: 40px !important;
  align-items: center;
  margin-bottom: 20px;
  overflow: hidden;
`

const Input = styled.input`
  flex: 1;
  padding-left: 16px;
  width: 100 %;
  outline: none;
  border: none;
  position: relative;
  box-sizing: border - box;
  font-weight: 300;
  :placeholder: {
    font-size: 5px;
  }
`

const CloseCrossWrapper = styled.div`
  margin-right: 10px;
  color: ${Theme.colors.blueArtizen};
  display: flex;
`
